// extracted by mini-css-extract-plugin
export default {"loading-container":"Loading_loading-container__uXWX4","loading-content":"Loading_loading-content__L0feT"};